/**
 * External Dependencies
 */
import 'jquery';
import 'jquery-match-height';
import 'slick-carousel/slick/slick.min';

import SmoothScroll from './modules/smooth-scroll';
new SmoothScroll();

import Header from './modules/header';
new Header();

import simpleCarousel from './modules/simple-carousel';
if( $('.js-simple-carousel').length  || $('.js-simple-carousel-rtl').length) {
	new simpleCarousel();
}

import mobileSlider from './modules/mobile-slider';
if( $('.js-mobile-slider').length ) {
	new mobileSlider();
}

import featuredMediaLibrary from './modules/featured-media-library';
if( $('.js-featured-media-library__video').length ) {
	new featuredMediaLibrary();
}

import heroSlider from './modules/hero-slider';
if( $('.js-hero-slider').length ) {
	new heroSlider();
}

import heroSliderOverlaidtext from './modules/hero-slider-overlaid-text';
if( $('.js-hero-slider-overlaid-text').length ) {
	new heroSliderOverlaidtext();
}

import videoPlayer from './modules/video-player';
if( $('.js-video-element').length ) {
	new videoPlayer();
}

import Tabs from './modules/tabs';
new Tabs();

import filterPress from './modules/filter-press';
new filterPress();

import filterSearch from './modules/filter-search';
new filterSearch();

import filterCreativecorner from './modules/filter-creativecorner';
new filterCreativecorner();

import newsletter from './modules/newsletter';
new newsletter();

import ModalVideo from './modules/ModalVideo';
new ModalVideo();

import Satellite from './modules/satellite';
new Satellite();

import Search from './modules/search';
new Search();

$(document).ready(() => {
  // $('.js-slick-carousel').each(function() {
  //   let data = $(this).attr('data-slick')
  //   $(this).slick(data)
  // });

  // $('.js-featured_content__match-height').matchHeight();

  // $('.js-latest-newsroom__img').matchHeight();
  // $('.js-latest-newsroom__title').matchHeight();
  // $('.js-latest-newsroom__excerpt').matchHeight();
  // $('.latest-newsroom img').matchHeight();

  // $('.js-featured-case-studies__img').matchHeight();
  // $('.js-featured-case-studies__title').matchHeight();
  // $('.js-featured-case-studies__excerpt').matchHeight();
  // $('.featured-case-studies img').matchHeight();

  // $('.js-latest-blog-posts__img').matchHeight({ byRow: false });
  // $('.js-latest-blog-posts__title').matchHeight({ byRow: false });
  // $('.js-latest-blog-posts__excerpt').matchHeight({ byRow: false });
  // $('.latest-blog-posts img').matchHeight({ byRow: false });

  //test 
  if (jQuery(".js-cc-filter__category-box")[0]){
    var urlParams = new URLSearchParams(window.location.search); //get all parameters
    var filter = urlParams.get('filter'); 
    if(filter){
      jQuery('.js-cc-filter__category-box #cc-'+filter).trigger("click");
      jQuery('.js-cc-filter__category-box #cc-'+filter+'-2').trigger("click");
      jQuery('.js-cc-filter__category-box #pt-'+filter).trigger("click");
      jQuery('.js-cc-filter__category-box #pt-'+filter+'-2').trigger("click");
      jQuery('.js-cc-filter__category-box #'+filter).trigger("click");
      jQuery('.js-cc-filter__category-box #'+filter+'-2').trigger("click");
    }
  }
});
